<template>
  <b-container class="mw-100 mt-3">
    <b-card class="mt-4 mb-4">
      <standard-table ref="logTable"
                      search-id="log-search"
                      :items="items"
                      :fields="fields"
                      :customFields="customFields"
                      :search-place-holder="`${$tc('message.example', 1)}: 10:26:10`"

                      :row-before-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                      :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                      :row-after-search="{cols: 12, sm: 12, md: 12, lg: 4, xl: 4, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                      :after-search="{cols: 12, sm: 12, md: 12, lg: 12, xl: 12}"

                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                      :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"
                      :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                      :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"

                      fullWidth="true"
                      noContainerPadding="true"
                      @rowInfo="openInfoModal">

        <b-container slot="row-after-search" class="mw-100 p-0 ">
          <b-row>
            <b-col cols="auto">
              <b-button v-on:click="resetFilters()" class="b-c-green" id="reset-filters">
                {{$t('message.resetFilters')}}
              </b-button>
            </b-col>

            <b-col cols="auto" class="mb-3">
              <b-button @click="showCollapse = !showCollapse" :class="showCollapse ? 'b-c-red' : 'b-c-green'">
                <span v-show="!showCollapse" class="when-opened">
                  {{$t('message.show')}} {{$tc('message.filter', 2).toLowerCase()}}
                </span>
                <span v-show="showCollapse" class="when-closed">
                  {{$t('message.hide')}} {{$tc('message.filter', 2).toLowerCase()}}
                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container slot="after-search" class="mw-100 p-0">
          <b-collapse id="my-collapse" v-model="showCollapse">
            <b-container class="mw-100 m-0 p-0">
              <b-row>
                <b-col cols="12" sm="12" md="6" lg="4" xl="3">
                  <b-form-group :label="$tc('message.user', 1)"
                                label-for="user-filter">
                    <model-list-select id="user-filter"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="userOptions && userOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="userFilter"
                                       :list="userOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="4" xl="3">
                  <b-form-group :label="$tc('message.from', 1)"
                                label-for="start">
                    <b-input-group>
                      <flat-pickr id="start"
                                  :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                  class="form-control"
                                  :readonly="false"
                                  v-model="start"
                                  :config="startDateConfig">
                      </flat-pickr>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="4" xl="3">
                  <b-form-group :label="$tc('message.to', 1)"
                                label-for="end">
                    <b-input-group>
                      <flat-pickr id="end"
                                  :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                  class="form-control"
                                  :readonly="false"
                                  v-model="end"
                                  :config="endDateConfig">
                      </flat-pickr>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="4" xl="3">
                  <b-form-group :label="$tc('message.section', 1)"
                                label-for="section-filter">
                    <model-list-select id="section-filter"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="$t('message.selectOption')"
                                       v-model="sectionFilter"
                                       :list="sectionOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="4" xl="3">
                  <b-form-group :label="$tc('message.page', 1)"
                                label-for="interface-filter">
                    <model-list-select id="interface-filter"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="$t('message.selectOption')"
                                       v-model="interfaceFilter"
                                       :list="interfaceOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="4" xl="3">
                  <b-form-group :label="$tc('message.methodType', 1)"
                                label-for="method-filter">
                    <model-list-select id="method-filter"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="$t('message.selectOption')"
                                       v-model="methodFilter"
                                       :list="methodOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-collapse>
        </b-container>

        <b-container slot="row-after-per-page" class="mw-100 p-0">
          <b-row>
            <b-col>
              <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0"
                        id="excel-button" @click="$refs.logTable.excel($tc('message.log', 2))"> Excel
              </b-button>
            </b-col>
          </b-row>
        </b-container>

        <template slot="method" slot-scope="row">
          <div v-if="row.item">
            <font-awesome-icon :icon="row.item.icon"
                               v-if="row.item.icon"/>
            {{row.item.method}}
          </div>
        </template>
      </standard-table>
    </b-card>

    <b-modal ref="infoModal" id="infoModal" :title="$t('info.infoModal')" size="lg">
      <b-container>
        <b-row>
          <b-col cols="12" sm="12" md="6" lg="4" xl="4">
            <div class="d-flex">
              <h6><b>{{$tc('message.user', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.userName}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="4" xl="4">
            <div class="d-flex">
              <h6><b>{{$tc('message.date', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.date}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="4" xl="4">
            <div class="d-flex">
              <h6><b>{{$tc('message.methodType', 1)}}:</b></h6>
              <font-awesome-icon :icon="infoItem.icon" class="ml-2"
                                 v-if="infoItem.icon"/>
              <h6 class="ml-1">{{infoItem.method}}</h6>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" sm="12" md="6" lg="4" xl="4">
            <div class="d-flex">
              <h6><b>{{$tc('message.section', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.section}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="4" xl="4">
            <div class="d-flex">
              <h6><b>{{$tc('message.page', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.interface}}</h6>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="infoItem.data && infoItem.data.mainMotivation">
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="d-flex">
              <h6><b>{{$tc('message.motivation', 1)}}:</b></h6>
              <h6 class="ml-2">{{$tc(motivations[infoItem.data.mainMotivation - 1].text, 1)}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="d-flex">
              <h6><b>{{$tc('message.note', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.data.mainNotes}}</h6>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="infoItem.data && infoItem.data.details && infoItem.data.details.length !== 0">
          <b-col cols="12">
            <div>
              <h5 class="c-green">{{ $tc('info.dataUsedByUser', 1) }}</h5>
            </div>
          </b-col>

          <b-col cols="6" sm="6" md="6" lg="6" xl="6" v-for="(item, index) in infoItem.data.details" :key="index">
            <div class="d-flex">
              <h6><b>{{ $tc(item.text, item.option) }}:</b></h6>
              <h6 class="ml-2" v-if="!item.key">{{item.value}}</h6>
              <h6 class="ml-2" v-if="item.key">{{getItemByKey(item)}}</h6>
            </div>
          </b-col>
        </b-row>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button class="b-c-green mr-3" v-on:click="closeInfoModal()">Ok</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { DateTime } from 'luxon'
import { cloneDeep, filter, orderBy, find, trim, first, concat, isNil } from 'lodash'
import { Italian } from 'flatpickr/dist/l10n/it'
import motivations from '@/plugins/motivations'
import logKeys from '@/plugins/log-keys'

export default {
  name: 'Logs',
  created () {
    this.getOptions().then(() => {
      this.fetchData()
    })
  },
  mounted () {
    this.$root.$on('change-lang', () => {
      if (this.$el.isConnected) {
        this.getStaticOptions()
        this.updateItems().then((items) => {
          this.items = items
          this.getFilterOptions(cloneDeep(items))
        })
      }
    })
    this.updateRanges(this.start, this.end)
  },
  data () {
    const today = DateTime.local().set({ hours: 0, minutes: 0, seconds: 0 })
    const genericDateOptions = {
      dateFormat: 'Y-m-d',
      mode: 'single',
      altFormat: 'D j M Y',
      altInput: true,
      locale: Italian,
      minDate: '',
      maxDate: DateTime.local().toSQLDate(),
      disable: []
    }
    const config = this.$route.meta.config

    return {
      motivations,
      config,
      DateTime,
      genericDateOptions,
      start: today.toSQLDate(),
      end: today.toSQLDate(),
      driverOptions: [],
      vehicleOptions: [],
      items: [],
      fields: [],
      customFields: [],
      showCollapse: false,
      startDateConfig: cloneDeep(genericDateOptions),
      endDateConfig: cloneDeep(genericDateOptions),
      interfaceFilter: '',
      dataTypeFilter: '',
      methodFilter: '',
      sectionFilter: '',
      userFilter: '',
      interfaceOptions: [],
      dataTypeOptions: [],
      methodOptions: [],
      sectionOptions: [],
      userOptions: [],
      infoItem: {}
    }
  },
  watch: {
    start (val) {
      this.updateRanges(val, this.end)
    },
    end (val) {
      this.updateRanges(this.start, val)
    },
    interfaceFilter (val) {
      this.updateItems().then((result) => {
        let items = result
        items = this.filterItems(items, 'interface', 'interfaceOptions', val)
        items = this.filterItems(items, 'function', 'dataTypeOptions', this.dataTypeFilter)
        items = this.filterItems(items, 'method', 'methodOptions', this.methodFilter)
        items = this.filterItems(items, 'section', 'sectionOptions', this.sectionFilter)
        items = this.filterItems(items, 'userName', 'userOptions', this.userFilter)
        this.items = items
      })
    },
    dataTypeFilter (val) {
      this.updateItems().then((result) => {
        let items = result
        items = this.filterItems(items, 'interface', 'interfaceOptions', this.interfaceFilter)
        items = this.filterItems(items, 'function', 'dataTypeOptions', val)
        items = this.filterItems(items, 'method', 'methodOptions', this.methodFilter)
        items = this.filterItems(items, 'section', 'sectionOptions', this.sectionFilter)
        items = this.filterItems(items, 'userName', 'userOptions', this.userFilter)
        this.items = items
      })
    },
    methodFilter (val) {
      this.updateItems().then((result) => {
        let items = result
        items = this.filterItems(items, 'interface', 'interfaceOptions', this.interfaceFilter)
        items = this.filterItems(items, 'function', 'dataTypeOptions', this.dataTypeFilter)
        items = this.filterItems(items, 'method', 'methodOptions', val)
        items = this.filterItems(items, 'section', 'sectionOptions', this.sectionFilter)
        items = this.filterItems(items, 'userName', 'userOptions', this.userFilter)
        this.items = items
      })
    },
    sectionFilter (val) {
      this.updateItems().then((result) => {
        let items = result
        items = this.filterItems(items, 'interface', 'interfaceOptions', this.interfaceFilter)
        items = this.filterItems(items, 'function', 'dataTypeOptions', this.dataTypeFilter)
        items = this.filterItems(items, 'method', 'methodOptions', this.methodFilter)
        items = this.filterItems(items, 'section', 'sectionOptions', val)
        items = this.filterItems(items, 'userName', 'userOptions', this.userFilter)
        this.items = items
      })
    },
    successFilter (val) {
      this.updateItems().then((result) => {
        let items = result
        items = this.filterItems(items, 'interface', 'interfaceOptions', this.interfaceFilter)
        items = this.filterItems(items, 'function', 'dataTypeOptions', this.dataTypeFilter)
        items = this.filterItems(items, 'method', 'methodOptions', this.methodFilter)
        items = this.filterItems(items, 'section', 'sectionOptions', this.sectionFilter)
        items = this.filterItems(items, 'userName', 'userOptions', this.userFilter)
        this.items = items
      })
    },
    userFilter (val) {
      this.updateItems().then((result) => {
        let items = result
        items = this.filterItems(items, 'interface', 'interfaceOptions', this.interfaceFilter)
        items = this.filterItems(items, 'function', 'dataTypeOptions', this.dataTypeFilter)
        items = this.filterItems(items, 'method', 'methodOptions', this.methodFilter)
        items = this.filterItems(items, 'section', 'sectionOptions', this.sectionFilter)
        items = this.filterItems(items, 'userName', 'userOptions', val)
        this.items = items
      })
    }
  },
  methods: {
    getOptions () {
      const axiosArray = []
      axiosArray.push(this.getVehicle())
      axiosArray.push(this.getDrivers())
      return Vue.myAll(axiosArray).then(r => r)
    },
    getVehicle () {
      return Vue.myGet(this, '/vehicles?all=true', 'vehicles').then(vehicles => {
        this.vehicleOptions = vehicles
        return this.vehicleOptions
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getDrivers () {
      return Vue.myGet(this, '/drivers', 'drivers').then(drivers => {
        this.driverOptions = drivers
        return drivers
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    fetchData (resetAll) {
      this.getStaticOptions()
      const today = DateTime.local().toSQLDate()
      const start = parseInt(DateTime.fromSQL(resetAll ? today : this.start).toMillis() / 1000, 10)
      const end = parseInt(DateTime.fromSQL(resetAll ? today : this.end).set({ hours: 23, minutes: 59, seconds: 59 }).toMillis() / 1000, 10)
      this.$root.$emit('activeLoader', true)
      const path = `/application_logs?start=${start}&end=${end}`

      if (resetAll) {
        this.start = today
        this.end = today
        this.startDateConfig = cloneDeep(this.genericDateOptions)
        this.endDateConfig = cloneDeep(this.genericDateOptions)
        const all = this.$tc('message.all', 1)
        this.originalItems = []
        this.items = []

        this.interfaceOptions = [{ value: '', text: all }]
        this.dataTypeOptions = [{ value: '', text: all }]
        this.methodOptions = [{ value: '', text: all }]
        this.sectionOptions = [{ value: '', text: all }]
        this.userOptions = [{ value: '', text: all }]
        this.interfaceFilter = ''
        this.dataTypeFilter = ''
        this.methodFilter = ''
        this.sectionFilter = ''
        this.userFilter = ''
      }

      this.getAllLogs(path).then(logs => {
        this.originalItems = orderBy(logs, ['ts'], ['asc'])
        this.getFilterOptions(this.originalItems)
        this.updateItems().then((result) => {
          this.items = result
        })
        this.$root.$emit('activeLoader', false)
      })
    },
    getAllLogs (path, page, parentLogs) {
      if (path) {
        return Vue.myGet(this, path).then(obj => {
          return this.getAllLogs(null, obj.nextPage, obj.logs).then(results => concat(parentLogs, results))
        })
      }

      if (page) {
        return Vue.myGet(this, `/application_logs?page=${page}`).then(obj => {
          return this.getAllLogs(null, obj.nextPage, obj.logs).then(results => concat(parentLogs, results))
        })
      }
      return new Promise(resolve => resolve(parentLogs))
    },
    getStaticOptions () {
      this.fields = [
        { key: 'info', label: '', hideInExcel: true },
        { key: 'userName', label: this.$tc('message.user', 1), sortable: true, sortDirection: 'desc' },
        { key: 'date', label: this.$t('message.date'), sortable: true, sortDirection: 'desc' },
        { key: 'section', label: this.$tc('message.section', 1), sortable: true, sortDirection: 'desc' },
        { key: 'interface', label: this.$tc('message.function', 1), sortable: true, sortDirection: 'desc' },
        { key: 'method', label: this.$tc('message.activity', 1) },
      ]
      this.customFields = [
        { key: 'method', label: this.$tc('message.methodType', 1), position: 6 }
      ]
    },
    getFunctionName (path, getAbsolutePath) {
      let editedPath = ''
      if (!isNil(path)) {
        if (typeof path !== 'string') return ''
        if (!isNil(path) && path.includes('"')) path = JSON.parse(path)
        if (typeof path !== 'string') return ''
        path = first(path.split('?'))

        if (path.includes('enum')) {
          if (path.replace(/[/]/g, '').length >= 2) {
            path.split('/').forEach((chunk, index) => {
              if (index <= 2) editedPath = `${editedPath}${chunk !== '' ? '/' + chunk : chunk}`
            })
          }
        } else {
          if (path.replace(/[/]/g, '').length >= 1) {
            path.split('/').forEach((chunk, index) => {
              if (index <= 1) editedPath = `${editedPath}${chunk !== '' ? '/' + chunk : chunk}`
            })
          }
        }

        if (getAbsolutePath) return editedPath
        if (path === '/') return this.$tc('path./login', 1)
        return this.$tc('path.' + editedPath, 1)
      }
      return ''
    },
    getInterfaceName (name) {
      if (name && Array.isArray(name)) {
        let editedName = ''
        name.forEach((chunk, index) => {
          const nameChunk = index === 0
            ? this.$tc(chunk.option, chunk.num || 1)
            : this.$tc(chunk.option, chunk.num || 1).toLowerCase()

          editedName = index === 0 ? nameChunk : `${editedName} ${nameChunk}`
        })
        return editedName
      }
      return ''
    },
    getSectionName (path) {
      if (!path) return null
      const route = Vue.myFindSection(path)
      return this.getInterfaceName(route && route.title)
    },
    updateItems () {
      return new Promise(resolve => {
        const logs = cloneDeep(this.originalItems)
        const editedItems = []
        if (logs && logs.length !== 0) {
          logs.forEach(log => {
            if (log) {
              const editedItem = log
              editedItem.section = this.getSectionName(cloneDeep(log.data && log.data.routePath))
              editedItem.date = DateTime.fromMillis(log.ts * 1000).toFormat('dd-MM-yyyy HH:mm:ss')
              editedItem.function = this.getFunctionName(cloneDeep(log.function))
              editedItem.method = this.$tc('message.' + log.mode, 1)
              editedItem.interface = this.getInterfaceName(log.data && log.data.route)

              switch (log.mode) {
                case 'get':
                  editedItem.icon = 'download'
                  break

                case 'post':
                  editedItem.icon = 'plus'
                  break

                case 'put':
                  editedItem.icon = 'pencil-alt'
                  break

                case 'delete':
                  editedItem.icon = 'trash-alt'
                  break

                default:
                  break
              }

              editedItems.push(editedItem)
            }
          })
        }
        resolve(editedItems)
      })
    },
    getFilterOptions (logs) {
      const all = this.$tc('message.all', 1)
      const interfaces = [{ text: all, value: '' }]
      const dataType = [{ text: all, value: '' }]
      const requestType = [{ text: all, value: '' }]
      const sections = [{ text: all, value: '' }]
      const users = [{ text: all, value: '' }]
      this.interfaceOptions = []
      this.dataTypeOptions = []
      this.methodOptions = []
      this.sectionOptions = []
      this.userOptions = []

      logs.forEach(log => {
        if (log) {
          const functionName = this.getInterfaceName(log.data && log.data.route)
          const dataName = this.getFunctionName(cloneDeep(log.function))
          const methodName = this.$tc('message.' + log.mode, 1)
          const sectionName = this.getSectionName(cloneDeep(log.data && log.data.routePath))

          const foundedInterface = find(interfaces, obj => obj.text === functionName)
          const foundedData = find(dataType, obj => obj.text === dataName)
          const foundedMethod = find(requestType, obj => obj.text === methodName)
          const foundedSection = find(sections, obj => obj.text === sectionName)
          const foundedUser = find(users, obj => obj.text === log.userName)

          if (!foundedInterface && functionName) interfaces.push({ value: interfaces.length, text: functionName })
          if (!foundedData && dataName) dataType.push({ value: dataType.length, text: dataName })
          if (!foundedMethod) requestType.push({ value: requestType.length, text: methodName })
          if (!foundedSection && sectionName) sections.push({ value: sections.length, text: sectionName })
          if (!foundedUser && log.userName) users.push({ value: users.length, text: log.userName })
        }
      })

      this.interfaceOptions = interfaces
      this.dataTypeOptions = dataType
      this.methodOptions = requestType
      this.userOptions = users
      this.sectionOptions = sections
    },
    resetFilters () {
      this.fetchData(true)
    },
    updateRanges (start, end) {
      const today = DateTime.local()
      const parsedStart = start ? DateTime.fromSQL(start) : null
      const parsedEnd = end ? DateTime.fromSQL(end) : null
      const threeMonthFromSTart = parsedStart.plus({ months: 3 })

      this.startDateConfig.minDate = end ? parsedEnd.plus({ months: -3 }).toSQLDate() : null
      this.startDateConfig.maxDate = end ? (end > today ? today.toSQLDate() : end) : today.toSQLDate()
      this.endDateConfig.minDate = start || null
      this.endDateConfig.maxDate = start ? (threeMonthFromSTart > today ? today.toSQLDate() : threeMonthFromSTart.toSQLDate()) : today.toSQLDate()

      this.fetchData()
    },
    filterItems (items, by, options, val) {
      if ((!val && val !== 0) || val === '') return items

      const text = find(this[options], obj => obj.value === val).text

      return filter(items, obj => trim(obj[by]) === trim(text))
    },
    openInfoModal (obj) {
      this.infoItem = obj.item

      this.$refs.infoModal.show()
    },
    closeInfoModal () {
      this.$refs.infoModal.hide()
    },
    getItemByKey (item) {
      if (item.key === logKeys.vehicle) {
        const vehicle = find(this.vehicleOptions, o => o.id === item.value)
        const brand = (vehicle.type && vehicle.type.brand) || ''
        const model = (vehicle.type && vehicle.type.model) || ''

        return `${vehicle.plateNumber} ${brand} ${model}`
      }

      if (item.key === logKeys.driver) {
        const driver = find(this.driverOptions, o => o.id === item.value)
        return `${driver.surname} ${driver.name}`
      }

      return this.$tc('message.error', 1)
    }
  }
}
</script>
